<template>
  <tr :key="name">
    <TooltipTd
      :variableName="name"
      :description="description"
      :deviceType="deviceType"
      :node="node"
      >
    </TooltipTd>
    <td align="right">
      <a href="#" @click="setExternal()"><v-icon>mdi-eye</v-icon></a>
    </td>
  </tr>
</template>

<script>
import Vue from 'vue'
import TooltipTd from '../../tooltip-td.vue'
import { readAttributeValue } from '../../../helpers/utils.ts'

export default Vue.extend({
  name: 'matrix',
  props: {
    name: {},
    node: {},
    types: {},
    variables: {},
    description: {},
    deviceType: {},
    unit: {}
  },

  components: {
    TooltipTd
  },

  methods: {
    setExternal () {
      this.$store.commit('setExternalWindow', true)
      this.$store.commit('setExternalWindowContent', {
        content: this.resolvedValue(), type: 'matrix'
      })
    },

    resolvedValue () {
      const value = readAttributeValue(this.node, this.name, this.variables)
      return JSON.parse(value)
    }
  },

  watch: {
    variables (value) {
      this.$store.commit('setExternalWindowContent', {
        content: this.resolvedValue(), type: 'requestMemory'
      })
    }
  }
})
</script>
